import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	MatSelect,
	MatSelectTrigger,
	MatOption,
} from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-military-time-picker',
	templateUrl: './military-time-picker.component.html',
	styleUrls: ['./military-time-picker.component.scss'],
	imports: [MatSelect, FormsModule, MatSelectTrigger, MatOption],
})
export class MilitaryTimePickerComponent implements OnInit {
	timeValues: CustomPicker[] = [];
	@Input() passedInTime = '';
	@Input() disabled = false;
	@Input() endTimeMustBeAfter?: string;
	@Input() endTimeMustBeBefore?: string;
	/* eslint-disable-next-line @angular-eslint/no-output-on-prefix */
	@Output() onTimeSelected = new EventEmitter();

	generateTimeValues(): void {
		this.timeValues = [];
		for (let i = 0; i < 24; i++) {
			const singleDigitCheck = `00${i}`.slice(-2);
			const hour = {
				value: `${singleDigitCheck}:00:00`,
				valueName: `${singleDigitCheck} : 00`,
			};
			const halfHour = {
				value: `${singleDigitCheck}:30:00`,
				valueName: `${singleDigitCheck} : 30`,
			};

			this.timeValues.push(hour);
			this.timeValues.push(halfHour);
		}
		const hour24 = { value: '24:00:00', valueName: '24 : 00' };
		this.timeValues.push(hour24);
	}

	isTimeValid(time: string): boolean {
		if (this.endTimeMustBeAfter && time < this.endTimeMustBeAfter) {
			return false;
		}
		if (this.endTimeMustBeBefore && time > this.endTimeMustBeBefore) {
			return false;
		}
		return true;
	}

	get isCurrentTimeValid(): boolean {
		return this.isTimeValid(this.passedInTime);
	}

	constructor() {}

	ngOnInit(): void {
		this.generateTimeValues();
	}

	onSelection(time: any): void {
		this.onTimeSelected.emit(time);
	}
}

export interface CustomPicker {
	value: string;
	valueName: string;
}
